import type { FC, ReactNode } from "react";

import { HeaderIcon } from "./HeaderIcon";
import { PanelSection } from "./PanelSection";
import { Text } from "./Text";

interface DataPanelProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  iconColor?:
    | "primary"
    | "success"
    | "warning"
    | "danger"
    | "violet"
    | "emerald"
    | "sky"
    | "amber"
    | "rose";
  actions?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
  headerClassName?: string;
  actionsClassName?: string;
}

export const DataPanel: FC<DataPanelProps> = ({
  title,
  subtitle,
  icon,
  iconColor,
  actions,
  children,
  className = "",
  bodyClassName = "",
  headerClassName = "",
  actionsClassName = "",
}) => {
  const headerContent = (
    <div
      className={`flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between ${headerClassName}`
        .trim()
        .replace(/\s+/g, " ")}
    >
      <div className="flex items-center gap-3">
        {icon && <HeaderIcon icon={icon} color={iconColor} />}
        <div className="min-w-0">
          <h2 className="truncate text-sm font-semibold tracking-tight text-gray-900 dark:text-white">
            {title}
          </h2>
          {subtitle && (
            <Text variant="caption" as="p" className="mt-0.5">
              {subtitle}
            </Text>
          )}
        </div>
      </div>
      {actions && (
        <div
          className={`flex w-full items-center gap-3 md:w-auto ${actionsClassName}`
            .trim()
            .replace(/\s+/g, " ")}
        >
          {actions}
        </div>
      )}
    </div>
  );

  return (
    <PanelSection
      headerContent={headerContent}
      className={className}
      bodyClassName={bodyClassName}
    >
      {children}
    </PanelSection>
  );
};
